import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Firebase configuration - Replace with your actual config
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "your-api-key",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "your-project.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "your-project-id",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "your-project-id.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "123456789",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "your-app-id"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig, 'cms-app'); // Named instance to avoid conflicts

// Initialize Firebase services
export const cmsAuth = getAuth(app);
export const cmsDb = getFirestore(app);
export const cmsStorage = getStorage(app);
export const cmsFunctions = getFunctions(app);

// Optionally connect to local emulators when explicitly enabled
// Set REACT_APP_FIREBASE_USE_EMULATORS=true to enable emulator usage in development
if (
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_FIREBASE_USE_EMULATORS === 'true'
) {
  const connectToEmulators = async () => {
    try {
      // Try connecting to emulators; if they're not running, the SDK will report network errors on requests
      console.log('Attempting to connect to Firebase emulators...');
      connectAuthEmulator(cmsAuth, 'http://localhost:9099', { disableWarnings: true });
      connectFirestoreEmulator(cmsDb, 'localhost', 8080);
      connectStorageEmulator(cmsStorage, 'localhost', 9199);
      connectFunctionsEmulator(cmsFunctions, 'localhost', 5001);
      console.log('Connected to Firebase emulators');
    } catch (error) {
      // Emulators already connected or not available
      console.log('Firebase emulators not available or already connected');
    }
  };

  // Only attempt to connect if explicitly enabled
  connectToEmulators();
}